export const isTooltipLocallyStored = key => !!localStorage.getItem(key)

export const removeTootipFromDOM = tooltipKey => {
  const innerTooltip = document.getElementById(`js-${tooltipKey}`)
  const tooltip = innerTooltip && innerTooltip.closest('hd-tooltip')
  tooltip && tooltip.remove()
}

export const manageTooltipWithStorage = tooltipKey => {
  const innerTooltip = document.getElementById(`js-${tooltipKey}`)
  if (!innerTooltip) return false
  const tooltip = innerTooltip && innerTooltip.closest('hd-tooltip')
  const closeTooltipBtn = tooltip && tooltip.querySelector('.js-hd-tooltip-close')
  
  if (isTooltipLocallyStored(tooltipKey)) {
    tooltip.remove()
    return 
  }

  closeTooltip({tooltip, closeTooltipBtn, tooltipKey})
}

export const appendTooltip = (siblingElement, parentElement, tooltipKey, position, coord, orientation) => {
  const innerTooltip = document.getElementById(`js-${tooltipKey}`)
  if (!innerTooltip) return false
  const tooltip = innerTooltip.closest('hd-tooltip')
  tooltip.removeAttribute('style')

  let commonParent = parentElement
  
  if (parentElement.tagName.toLowerCase() === 'ul') {
    commonParent = parentElement.parentElement;
  }

  commonParent.style.position = 'relative'
  innerTooltip.classList.remove('afd-hide')

  setTooltipCoordinates(coord, tooltip, siblingElement, position, orientation)
}

const closeTooltip = params => {
  const { tooltip, closeTooltipBtn, tooltipKey } = params
  closeTooltipBtn && closeTooltipBtn.addEventListener('click', () => {
    tooltip.remove()
    localStorage.setItem(tooltipKey, 'removed')
  })
}

const setTooltipCoordinates = (coord, tooltip, selectorElement, position, orientation) => {
  const { innerWidth } = window
  const device = innerWidth > 1039 ? 'desktop' : ( innerWidth < 768 ? 'mobile' : 'tablet')
  let parsedCoordinate = JSON.parse(coord)
  parsedCoordinate = parsedCoordinate[device] || parsedCoordinate['desktop']
  const { left, right } = parsedCoordinate

  if (!left && !right) {
    const { left: selectorPositionLeft, width } = selectorElement.getBoundingClientRect()
    let positionX = selectorPositionLeft

    if (position.toLowerCase() === 'bottom' && ['bottomMiddle', 'topMiddle'].includes(orientation) ) {
      positionX = -width
    }

    parsedCoordinate = { left: positionX + 'px', ...parsedCoordinate}
  }
  
  const styles =  { position: 'absolute', ...parsedCoordinate }
  
  Object.entries(styles).forEach(([attr, value]) => {
    tooltip.style[attr] = value
  })
}